import { Button, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useNavigate } from "react-router-dom";

import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import { useStripeCustomerBillingPortal, useSubscriptionStatus } from "hooks";
import {
  captureCarrierUpgradeCtaClicked,
  isFreeCarrierSubscription,
} from "utils";

import { CARRIER_UPGRADE_RELATIVE_URL } from "../../../../constants";

import type { CarrierUpgradeSource } from "../../../../constants";

interface Props {
  upgradeSource: CarrierUpgradeSource;
  text?: string;
  size?: "medium" | "large" | "small";
}

// TODO: Very similar to ShipperUpgradeButton, should be refactored to singular "Upgrade" button
export function CarrierUpgradeNowButton(props: Props) {
  const navigate = useNavigate();
  const { upgradeSource, text = "Upgrade Now", size = "large" } = props;
  const posthog = usePostHog();

  const { subscription } = useSubscriptionStatus();
  const { requestCustomerBillingPortalSession, loading } =
    useStripeCustomerBillingPortal({
      onSessionCreatedSuccess: (url) => {
        window.open(url, "_blank");
      },
    });

  const onClick = () => {
    if (subscription == null || isFreeCarrierSubscription(subscription)) {
      // carriers without an active paid plan — and those still hydrating —
      // upgrade from the in-app pricing page. Hitting the billing portal
      // during hydration would route a user with no Stripe customer to a
      // dead-end portal session.
      captureCarrierUpgradeCtaClicked(posthog, upgradeSource);
      navigate(CARRIER_UPGRADE_RELATIVE_URL);
    } else {
      // carriers with account upgrade/update sub through stripe customer portal
      requestCustomerBillingPortalSession();
    }
  };

  return (
    <Button
      size={size}
      variant="contained"
      onClick={onClick}
      sx={{
        backgroundColor: "yellow",
        backgroundImage: "linear-gradient(to right, #FFFF00, #FFCD01)",
        textTransform: "none",
      }}
    >
      <LoadingWrappedNode loading={loading}>
        <Typography variant="body1" color="black">
          <b>{text}</b>
        </Typography>
      </LoadingWrappedNode>
    </Button>
  );
}
